import { InputNumber } from "primereact/inputnumber";
import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { RadioButton } from "primereact/radiobutton";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import './Charts.css';
import { MissingNumberOptions } from "./Models.ts";
import { useTranslation } from "../Shared/i18n/useTranslation.ts";

export function Settings() {
    const {settings, setSettings} = useContext(SettingsContext);
    const t = useTranslation();

    function handleNumberOfMissingSelect(e) {
        let updatedSettings = {...settings};
        updatedSettings.NumberOfMissingNumbers = Number(e.target.value);
        setSettings(updatedSettings);
    } 
    
    function handlePagesChange(e) {
        let value = parseInt(e.value);
        if (value > 50) {
            value = 50;
        }
        
        let updatedSettings = {...settings};
        updatedSettings.NumberOfPages = isNaN(value) ? 1 : value;
        setSettings(updatedSettings);
    } 
    let radioButtonList: React.JSX.Element[] = [];
    let i = 1;
    MissingNumberOptions.forEach(option => {
        radioButtonList.push(
            <div key={i}>
                <RadioButton  inputId={`missingNumbers-${option}`} value={option} checked={settings.NumberOfMissingNumbers === option} onChange={handleNumberOfMissingSelect}/>
                <label htmlFor={`missingNumbers-${option}`}>{option}</label>
            </div>
        )
        i++;
    });
    
    const radioButtons = (
        <div className='radioButtons' role='radiogroup' aria-label={t('charts.numberOfMissingNumbersAria')}>
            {radioButtonList}
        </div>
    );

    return (
        <div className='chartSettings'>
            <span className='settingLabel'>{t('charts.numberOfMissingNumbersLabel')}</span>
            {radioButtons}
            <br/>
            <label htmlFor='chartNumberOfPages'>{t('charts.numberOfPagesLabel')}</label>
            <InputNumber  inputId='chartNumberOfPages' className='pagesInput' value={settings.NumberOfPages} onChange={handlePagesChange} showButtons
                pt={{
                    incrementButton: { 'aria-label': t('charts.addPageAria') },
                    decrementButton: { 'aria-label': t('charts.removePageAria') },
                }}/>
            {/* The mobile "Generate PDF" button used to live here. It read the
                hidden preview iframe's blob: URL and assigned it to
                window.location, which iOS Safari often refuses and which saved
                the file under a raw UUID. ChartPreview renders a real
                PDFDownloadLink for those visitors instead. */}
        </div>
    )
}